import {version} from '../../package.json'
import {LOCALHOST_VERSION, IS_LOCALHOST} from '../constants'

export const getVersion = (): string => {
    if (IS_LOCALHOST) {
        return LOCALHOST_VERSION
    }

    return version
}
